import {handleRefresh} from '~/shared/services/auth/auth';

class RefreshQueue {
  queue: (() => Promise<void>)[];

  refreshHandlingInProcess: boolean;

  constructor() {
    this.queue = [];
    this.refreshHandlingInProcess = false;
  }

  processQueue = async () => {
    const action = this.queue.shift()!;

    // The queue has to keep draining even when a task ends badly, otherwise a single failure leaves
    // refreshHandlingInProcess stuck on and every later refresh waits on a queue that never moves.
    try {
      await action();
    } finally {
      if (this.queue.length) {
        this.processQueue();
      } else {
        this.refreshHandlingInProcess = false;
      }
    }
  };

  dequeue = async () => {
    if (!this.refreshHandlingInProcess && this.queue.length) {
      this.refreshHandlingInProcess = true;

      this.processQueue();
    }
  };

  enqueue = async <R>(err: unknown, action?: (args: any) => any, args?: any): Promise<R> => new Promise((resolve, reject) => {
    this.queue.push(async () => {
      // A rejection here is the retried action failing. It has to be passed on to the caller - left
      // unhandled the promise below never settles and the caller awaits it forever.
      try {
        resolve(await handleRefresh(err, action, args));
      } catch (error) {
        reject(error);
      }
    });

    this.dequeue();
  });
}

const refreshQueueSingleton = new RefreshQueue();

export default refreshQueueSingleton;
